import rolesController from './rolesController'

export default rolesController



// WEBPACK FOOTER //
// ../src/controllers/rolesController/index.js